import { render, staticRenderFns } from "./air_quality_card.vue?vue&type=template&id=7bf86b46&scoped=true&"
import script from "./air_quality_card.vue?vue&type=script&lang=js&"
export * from "./air_quality_card.vue?vue&type=script&lang=js&"
import style0 from "./air_quality_card.vue?vue&type=style&index=0&id=7bf86b46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf86b46",
  null
  
)

export default component.exports